import type {
  DynamicGroupListBffResponseApi,
  DynamicGroupResourceBffReadApi,
  SearchDynamicGroupsBffV1MutationResponseApi,
} from '@ingenico/api-sdk-configuration-private';
import type {
  ConfigurationResourceListResponseV2Api,
  ConfigurationResourceReadBffV2Api,
  ConfigurationResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { MappedDynamicGroupResourceApi } from '@ingenico/react-ui';
import { toString } from 'lodash-es';
import type { DynamicGroupResource } from '../../models/dynamicGroups.model';
import type {
  AutomatorsSet,
  DynamicGroupListResponseFront,
  IConfigResource,
  IConfigResourceBff,
} from '../../../model/configProfileV2.model';
import type { IConfigProfileForDeploymentRequest } from '../../../model/deploymentRequest.model';

export function mapDynamicGroupsByConfigProfileId(
  response: SearchDynamicGroupsBffV1MutationResponseApi,
  automatorIds: AutomatorsSet[],
): DynamicGroupListResponseFront {
  return {
    ...response,
    data: response.data as unknown as DynamicGroupResource[],
    automatorIds,
  };
}

export function mapConfigByIdV2(config: ConfigurationResourceReadV2Api): IConfigResource {
  return {
    ...config, // TICKET MDMGT-7043 Upgraded api-sdk, and on new api, creator.name doesn't exist
  };
}

export function mapConfigByIdBffV2(config: ConfigurationResourceReadBffV2Api): IConfigResourceBff {
  return {
    ...config,
  };
}

export function mapDynamicGroupsList(
  response: DynamicGroupListBffResponseApi,
): SearchDynamicGroupsBffV1MutationResponseApi {
  return response;
}

export function mapGetDynamicGroupById({
  description,
  id,
  name,
  searchRequest,
  createdBy,
  creationDate,
  updateDate,
  updatedBy,
}: DynamicGroupResourceBffReadApi): MappedDynamicGroupResourceApi {
  return {
    description: toString(description),
    id: toString(id),
    name: toString(name),
    searchRequest: searchRequest ?? { filters: [], sort: {} },
    createdBy: createdBy ?? { id: toString(id), name: toString(name) },
    creationDate: toString(creationDate),
    updateDate: toString(updateDate),
    updatedBy: updatedBy ?? { id: toString(id), name: toString(name) },
  };
}

export function mapConfigurationProfilesForDeploymentRequest(
  response: ConfigurationResourceListResponseV2Api,
): IConfigProfileForDeploymentRequest[] {
  return response.data.map((profile) => ({ id: profile.id, name: toString(profile.name) }));
}
